import type { Route } from '@/core/router.types'
import { GLOBAL_ADMIN_AUTHORIZE_ROLES } from '@/features/globalAdministration/utils/globalAdministration'

type ReportingLicensesComponent = typeof import('./Details/features/ReportingLicenses/ReportingLicenses').default
type SubsidiariesComponent = typeof import('./Details/features/Subsidiaries/Subsidiaries').default

export default [
  {
    path: '/global-admin/reporting-licenses',
    query: '',
    authorize: [...GLOBAL_ADMIN_AUTHORIZE_ROLES],
    requireParentTenant: true,
    flushTop: true,
    component: () => import('./Details/features/ReportingLicenses/ReportingLicenses'),
    response: (data: unknown) => ({
      title: 'Reporting & Licenses',
      description: 'Global administration reporting and licenses page.',
      props: data,
    }),
  } as unknown as Route<ReportingLicensesComponent>,
  {
    path: '/global-admin/subsidiaries',
    query: '',
    authorize: [...GLOBAL_ADMIN_AUTHORIZE_ROLES],
    requireParentTenant: true,
    flushTop: true,
    component: () => import('./Details/features/Subsidiaries/Subsidiaries'),
    response: (data: unknown) => ({
      title: 'Subsidiaries',
      description: 'Global administration subsidiaries page.',
      props: data,
    }),
  } as unknown as Route<SubsidiariesComponent>,
] as const
